import React, { useState } from 'react';
import './Header.css';
import { NavLink, useHistory, Link } from 'react-router-dom';


// Importing images:
import sun_img from '../../resources/sun1.png'
import moon_img from '../../resources/moon.png'

import SearchFiles from './SearchFiles';

// Other Imports:
import { auth } from '../User/include/Authorize'
import { useStateValue } from '../../utils/Provider/StateProvider';
// font-Awesome lib: // npm install --save font-awesome
import 'font-awesome/css/font-awesome.min.css';




function Header() {
    const history = useHistory();
    const [{ user }, dispatch] = useStateValue();
    const [menuSlider, displayMenuSlider] = useState(false)

    const [searchText, setSearchText] = useState('')

    // Logout Option:
    const handleLogout = () => {
        if (user) {
            auth.signOut();
            dispatch({
                type: 'SET_USER',
                user: null
            })
        }
    }

    const [toggle, onToggle] = useState(true);
    const setToggle = () => {
        onToggle(!toggle)

    }


    return (
        <nav className='navbar flex-row-spaceBetween'>

            <div className='navbar_title_div' onClick={() => history.push("/")}>
                <h3 className='nav_bar_title'>FamilyPlot</h3>
            </div>

            <div className='navbar_quicklinks flex-row-spaceEvenly'>
                
                    <div className='navbar_Search_div'>
                        <input className='navbar_Search' placeholder='search' type='text' value={searchText} onChange={e => {setSearchText(e.target.value)}} />
                        <i class="fa fa-search" aria-hidden="true"></i>
                    </div>
                


                {user ?
                    <div className='navbar_login_link dropdown'>
                        <Link>
                            {/* Hello, {user.displayName} */}
                            Hello, {user ? user.displayName : 'Guest'}
                        </Link>

                        <div class="dropdown_content ">
                            <Link to='/profile'>Profile</Link>
                            <Link to='#' onClick={handleLogout}>Logout</Link>
                        </div>
                    </div>
                    :
                    <div className='nav_links user_link navbar_login_link'><Link to={'/login'} activeClassName='active'>Login</Link></div>
                }




                <div className='toggle toggle1' onClick={setToggle}
                    style={toggle ?
                        { backgroundColor: '#ccc', transition: '0.9s ease' } :
                        { backgroundColor: '#2196F3', transition: '0.9s ease' }
                    }
                >

                    <img style={toggle ? null : { transform: 'translate(10.2px, -5px)', width: '35px', height: '35px' }}
                        className='slider' alt=''

                        src={toggle ?
                            moon_img
                            :
                            sun_img
                        }
                    />
                </div>

                {/* When Toggle is 500px-- */}
                <div className='toggle toggle2' onClick={setToggle}
                    style={toggle ?
                        { backgroundColor: '#ccc', transition: '0.9s ease' } :
                        { backgroundColor: '#2196F3', transition: '0.9s ease' }
                    }
                >

                    <img style={toggle ? null : { transform: 'translate(10.2px, -5px)', width: '35px', height: '35px' }}
                        className='slider' alt=''

                        src={toggle ?
                            moon_img
                            :
                            sun_img
                        }
                    />
                </div>

                <div className='header_container_quick_menu'onClick={() => displayMenuSlider(true)} >
                    <i class="fa fa-bars fa-lg" aria-hidden="true"></i>
                </div>

            </div>

            {menuSlider ? 
                <div className='header_slider_menu_mainDiv'>
                    <div className='header_slider_menu_mainDiv_close' onClick={() => displayMenuSlider(false)}></div>

                    <div className='header_slider_menu_mainDiv_content'>
                        

                        <div className='header_slider_mainDiv_content_row'>
                            <h3>Welcome to <span>FamilyPlot</span></h3>
                            <i class='fa fa-times fa-lg' arial-hidden='true'  onClick={() => displayMenuSlider(false)}></i>
                        </div>
                        <hr />


                        <div>
                            <p><b>Hello, {user ? user.displayName : "Guest"}</b></p>
                            {user? <p>{user.email}</p> : null}
                        </div>

                        <br />

                        <div className='header_slider_mainDiv_quickLinks'>
                            <div onClick={() => {history.push("/"); displayMenuSlider(false)}}>
                                <i class='fa fa-home' arial-hidden='true'></i>
                                <span>Home</span>
                            </div>


                            <div onClick={() => {history.push("/");  displayMenuSlider(false)}}>
                                <i class='fa fa-user' arial-hidden='true'></i>
                                <span>Profile</span>
                            </div>


                            {user ?

                                <div onClick={() => {history.push("/"); handleLogout(); displayMenuSlider(false)}}>
                                    <i class='fa fa-sign-out' arial-hidden='true'></i>
                                    <span>Logout</span>
                                </div>

                            :

                                <div onClick={() => {history.push("/login");  displayMenuSlider(false)}}>
                                    <i class='fa fa-sign-in' arial-hidden='true'></i>
                                    <span>Login</span>
                                </div>
                            }
                        </div>
                    </div>

                </div>
                :
                null
            }

            {/* When You are Searching */}
            { user && searchText ? 
                <SearchFiles text={searchText} handleClear={() => setSearchText("")} />
            :
                null
            }
        </nav>
    )
}

export default Header